<script setup lang="ts">
import { TransitionProps } from 'vue';
interface Props {
  group?: boolean;
}

const transitionAttributes = {
  'enter-active-class': 'tw-duration-300 tw-ease-out',
  'enter-from-class': 'tw-transform tw-opacity-0',
  'enter-to-class': 'tw-opacity-100',
  'leave-active-class': 'tw-duration-100 tw-ease-in',
  'leave-from-class': 'tw-opacity-100',
  'leave-to-class': 'tw-transform tw-opacity-0',
} as TransitionProps;

defineProps<Props>();
</script>

<template>
  <transition-group v-if="group" v-bind="transitionAttributes">
    <slot> </slot>
  </transition-group>
  <transition v-else v-bind="transitionAttributes">
    <slot> </slot>
  </transition>
</template>
